<!--手机端宣传页-->
<template>
  <div style="width: 100%;height: 100%;position:relative">
    <img src="../assets/常态化宣传.jpg" style="width: 100vw;object-fit: contain"/>
    <a href="/Register_mobile" style="position:absolute;bottom:6%;left:0px;width: 100%;height: 5%">
    </a>
  </div>
</template>

<script>
  export default {
  name: "MobilePublicity",
    data() {
      return {
        dialog: true,
      };
    },
    methods: {
      goBack() {
        window.history.back();
      },
    },
};
</script>

<style scoped>
  .main {
    width: 80vw;
    height: 80vh;
    background: linear-gradient(153deg, #e5ffec 0%, #e4e4ff 100%);
    border-radius: 16px;
    margin:0 auto;
    margin-top: 10vh;
  }
  .content{
    padding-top: 50%;
    margin-left: 10%;
    width: 80%;
    font-size: 1rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 2rem;
  }
</style>
